module.exports = __webpack_public_path__ + "static/media/4ODA3.f7786181.jpg";